module.exports = __webpack_public_path__ + "img/10551398_L.a8a38352.png";